import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const reduxAuth = useSelector(state => state.auth.isAuthenticated);
  const localAuth = localStorage.getItem("authenticated") === "true"
    && !!localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN_KEY || "auth_token");
  return (reduxAuth || localAuth) ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
